export function makeTimeHtml(): string {
  return `<!doctype html>
<html>
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
    <style>
    :root {
      color-scheme: light;
      font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      background: transparent;
      color: rgba(17, 24, 39, 0.94);
    }
    * { box-sizing: border-box; }
    html, body {
      width: 100%;
      height: 100%;
      margin: 0;
      background: transparent !important;
      overflow: hidden;
    }
    body {
      display: grid;
      place-items: center;
      padding: 34px;
    }
    main {
      display: grid;
      grid-template-columns: minmax(170px, 30%) minmax(0, 1fr);
      gap: clamp(28px, 4vw, 58px);
      align-items: center;
      width: 100%;
      height: 100%;
      max-width: 1040px;
      margin: 0 auto;
      padding: clamp(26px, 4vw, 56px);
      border: 1px solid rgba(15, 23, 42, 0.12);
      border-radius: 14px;
      background: rgba(255, 255, 255, 0.74);
      box-shadow:
        0 24px 68px rgba(15, 23, 42, 0.14),
        inset 0 1px 0 rgba(255, 255, 255, 0.84);
    }
    img {
      width: 100%;
      max-height: 78%;
      object-fit: cover;
      border-radius: 7px;
      box-shadow: 0 24px 58px rgba(0,0,0,0.38);
    }
    .eyebrow {
      margin: 0 0 18px;
      color: rgba(71, 85, 105, 0.9);
      font-size: clamp(14px, 1.8vw, 20px);
      font-weight: 760;
      letter-spacing: 0.18em;
      text-transform: uppercase;
    }
    h1 {
      margin: 0;
      max-width: 760px;
      color: rgba(15, 23, 42, 0.96);
      font-size: clamp(38px, 5.5vw, 74px);
      font-weight: 780;
      line-height: 1.08;
      letter-spacing: 0;
    }
    .source {
      margin: 22px 0 16px;
      color: rgba(51, 65, 85, 0.74);
      font-size: clamp(18px, 2vw, 26px);
      font-weight: 700;
      letter-spacing: 0;
    }
    .summary {
      max-width: 780px;
      margin: 0 0 28px;
      color: rgba(51, 65, 85, 0.76);
      font-size: clamp(18px, 2.2vw, 30px);
      line-height: 1.38;
      letter-spacing: 0;
    }
    .rule {
      height: 1px;
      margin: 0 0 24px;
      background: rgba(15, 23, 42, 0.14);
    }
    ul {
      display: grid;
      gap: clamp(14px, 2vw, 25px);
      margin: 0;
      padding: 0;
      list-style: none;
    }
    li {
      display: grid;
      grid-template-columns: 18px minmax(0, 1fr);
      gap: 22px;
      color: rgba(30, 41, 59, 0.76);
      font-size: clamp(17px, 2.1vw, 28px);
      line-height: 1.36;
      letter-spacing: 0;
    }
    li::before {
      content: "";
      width: 13px;
      height: 13px;
      margin-top: 0.42em;
      border-radius: 99px;
      background: #ffb020;
      box-shadow: 0 0 24px rgba(255,176,32,0.35);
    }
    .bars {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 10px;
      margin-top: 26px;
      max-width: 480px;
    }
    .bar {
      height: 8px;
      border-radius: 99px;
      background: rgba(15,23,42,0.1);
      overflow: hidden;
    }
    .bar span {
      display: block;
      height: 100%;
      border-radius: inherit;
      background: linear-gradient(90deg, #ffb020, #30d158);
    }
    @media (max-height: 520px) {
      body { padding: 12px; }
      main {
        grid-template-columns: minmax(108px, 26%) minmax(0, 1fr);
        gap: 18px;
        padding: 15px;
        border-radius: 10px;
      }
      img { max-height: 82%; }
      .eyebrow {
        margin-bottom: 7px;
        font-size: 11px;
        letter-spacing: 0.16em;
      }
      h1 {
        font-size: clamp(23px, 4.4vw, 31px);
        line-height: 1.04;
      }
      .source {
        margin: 9px 0 6px;
        font-size: 12px;
      }
      .summary {
        margin-bottom: 9px;
        font-size: 12px;
        line-height: 1.24;
      }
      .rule {
        margin-bottom: 8px;
      }
      ul {
        gap: 5px;
      }
      li {
        grid-template-columns: 9px minmax(0, 1fr);
        gap: 9px;
        font-size: 11.5px;
        line-height: 1.18;
      }
      li::before {
        width: 6px;
        height: 6px;
      }
      .bars {
        display: none;
      }
    }
  </style>
</head>
<body>
  <main>
    <img src="/ui-demo/make-time-cover.png" alt="Make Time book cover" />
    <section>
      <p class="eyebrow">Writer Takeaway</p>
      <h1>Choose one daily highlight, then defend it</h1>
      <p class="source">Make Time by Jake Knapp, John Zeratsky</p>
      <p class="summary">Make Time reframes productivity as choosing what matters, adjusting defaults, and reflecting daily.</p>
      <div class="rule"></div>
      <ul>
        <li><span>Pick a daily highlight before the day reacts for you.</span></li>
        <li><span>Change device and app defaults to make focus easier.</span></li>
        <li><span>Reflect briefly, then adjust tomorrow's tactics.</span></li>
        <li><span>Defend attention from infinity pools that drain focus.</span></li>
      </ul>
      <div class="bars" aria-hidden="true">
        <div class="bar"><span style="width: 82%"></span></div>
        <div class="bar"><span style="width: 64%"></span></div>
        <div class="bar"><span style="width: 48%"></span></div>
      </div>
    </section>
  </main>
</body>
</html>`;
}
